/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import { BooleanFieldItemEdit } from "./edit-item";

const BooleanFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <BooleanFieldItemEdit />
        </FieldListEditWrapper>
    );
};
BooleanFieldEdit.displayName = "BooleanFieldEdit";
export { BooleanFieldEdit };
